import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorUpdateOutlineService } from '../../api/ai-creator'
import { aICreatorUpdateOutlineSuccess } from '../../reducers/ai-creator/action'
import { UPDATE_OUTLINE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* updateOutlineFlow(payload) {
  try {
    const { req, outlineId, callback } = payload

    const response = yield call(AICreatorUpdateOutlineService, req, outlineId)

    yield put(aICreatorUpdateOutlineSuccess(response == '' ? req : response))
    yield put(operationSuccess())
    if (callback) {
      callback(response)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorUpdateOutlineWatcher() {
  while (true) {
    const action = yield take(UPDATE_OUTLINE)
    const { payload } = action

    yield fork(generalSaga, updateOutlineFlow, payload, false)
  }
}
